
export function isValidInteger(str) {
  return /^-?\d+$/.test(str);
}